import { HttpClient } from "../HttpClient";

export const GetSubscriptionList = async ({
  searchString,
  isEnabled,
  sortColumn = "dateUpdated",
  sortOrder = "desc",
  pageNumber = 1,
  rowsPerPage = 10,
}) => {
  try {
    const { data } = await HttpClient.get("api/subscriptions", {
      params: {
        pageNumber,
        rowsPerPage,
        sortOrder,
        ...(sortColumn && { sortColumn }),
        ...(searchString && { searchString }),
        ...(isEnabled !== undefined && { isEnabled }),
      },
    });
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
